import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import '../shared/portal.css';

const root = document.getElementById('fitness-root');
if (!root) throw new Error('Fitness root element was not found.');
createRoot(root).render(<React.StrictMode><App /></React.StrictMode>);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'));
}
